import { Component, OnInit, ChangeDetectorRef, Input, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { WorkbenchService } from '../../../services/workbench.service';
import { prepareSections, prepareSectionData, checkActiveSection, findInvalidControls, multiSectionDataSave, removeMultipleForm, readOnlyMode, markFormGroupTouched } from '../../../controls/components/dynamic-form/dynamic-form.component';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { NotificationService } from '../../../services/shared/notification/notification.service';
import { DynamicSaveService } from '../../../controls/services/Dynamic-Save/dynamic-save.service';
import { cloneArray, jsonParse } from '../../../app.component';
import { environment } from '../../../../environments/environment';
import { ResumeReferralCopyService } from '../../../services/resume-referral-copy/resume-referral-copy.service';
import { ConfirmationComponent } from '../../shared/confirmation/confirmation.component';
import { ConfirmationComponentCopy } from '../../confirmation-copy/confirmation.component';
@Component({
  selector: 'app-internal-job-posting',
  templateUrl: './internal-job-posting.component.html',
  styleUrls: ['./internal-job-posting.component.scss'],
  providers: [WorkbenchService, DynamicSaveService]
})
export class InternalJobPostingComponent implements OnInit {
  dynamic_form: UntypedFormGroup | any = {};
  display_type: number;
  section_data;
  masters = [];
  t_id;
  dataSavedRef;
  flag = 1;
  description;
  value;
  @Input() requirement_id;
  @Input() referrer_id;
  resume_ref_display;
  other_data: any = {};
  terms_conditions = false;
  parsed_resume;
  @Input() CellClicked;
  callbackFuncRef;
  loading: boolean = false;

  @Input() user_id; constructor(private workbench_svc: WorkbenchService,
    private change_detector: ChangeDetectorRef,
    private notification_svc: NotificationService,
    private dialogref: MatDialogRef<InternalJobPostingComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data,
    private translate: TranslateService,
    private dynamic_svc: DynamicSaveService,
    private resume_serivce: ResumeReferralCopyService,
    private _snackBar: MatSnackBar,
    private dialog: MatDialog

  ) {
    this.dynamic_form = new UntypedFormGroup({});
  }

  ngOnInit() {
    this.other_data['requirement_id'] = this.requirement_id;
    this.other_data['form_code'] = 9899;

    this.resume_serivce.getResumeDetails(this.requirement_id, this.referrer_id).subscribe(res => {
      if (res['data']) {
        this.resume_ref_display = true;
        if (res['data'].termsandconditions) {
          this.description = res['data'].termsandconditions.description;
          this.value = res['data'].termsandconditions.value;
        }
      }
    });
    //this.dataSavedRef = this.dataSaved.bind(this);
    this.getDetails();
    this.callbackFuncRef = this.callbackFunc.bind(this);
  }
  callbackFunc(func, ev) {

    eval('this.' + func);
  }
  getDetails(flag?) {
    this.workbench_svc.getMaster({ form_code: 9899, t_id: 0, template_code: 8081 }).subscribe(res => {
      if (res['id']) {
        this.t_id = res['id'];
        this.other_data['t_id'] = res['id'];
      }
      if (res && res['data'] && res['data'].length) {
        this.section_data = res['data'];
        if (res['data'][0]) {
          this.display_type = res['data'][0].display_type_id;
        }
        prepareSections(this.section_data, this.dynamic_form, this.section_data, null, this.fb, this.display_type);

        this.workbench_svc.getFormMaster({}, { form_code: 9899, t_id: 0, template_code: 0 }).subscribe(masters => {
          this.masters = masters['data'].masters;
          this.change_detector.detectChanges();
        })
      }
      else {
        this.notification_svc.snackbar(res['message'], 'Close', 5000);
      }
    })
  }
  dataSaved(e) {
    // this.t_id = e;
    if (e) {
      this.dynamic_form = new UntypedFormGroup({});
      this.getDetails(1);
      // this.resetTab();
    }
  }
  onCancel() {
    this.dialogref.close()
  }
  markFormGroupTouched(formGroup: UntypedFormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      control.markAsDirty();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
  findInvalidControls(form_group) {
    const invalid = [];
    const controls = form_group.controls;
    if (controls && Object.keys(controls)) {
      for (const name in controls) {
        try {
          if (controls[name].invalid) {
            invalid.push(name);
          }
        } catch (err) {

        }
      }
    }

    return invalid;
  }
  termsConditions() {
    this.terms_conditions = !this.terms_conditions;
  }

  dynamicFormSave(section_list, form_group) {
    //if section supports multiple and api url is present or if section is not multiple
    //data has to be sent to backend for saving
    if (this.terms_conditions) {

      if (form_group.valid) {
        //if section is not multiple
        if (section_list && ((section_list.multiple && section_list.save_api_url != '') || !section_list.multiple)) {
          let processed_section_list = new Object();
          for (let i of Object.keys(section_list)) {
            if (typeof section_list[i] == "object" && section_list[i].length >= 0) {
              processed_section_list[i] = cloneArray(section_list[i]);
            }
            else if (typeof section_list[i] == "object") {
              processed_section_list[i] = Object.assign({}, section_list[i]);
            }
            else {
              processed_section_list[i] = section_list[i];
            }
          }
          // processed_section_list = Object.assign({}, section_list);

          if (processed_section_list && processed_section_list['section_id'] && form_group) {
            if (!processed_section_list['multiple_form']) {
              processed_section_list['data'] = [Object.assign({}, this.dynamic_form.get([section_list.section_id]).value)];
            }
            else {
              let section_form = processed_section_list['multiple_form'];
              let form_value_arr = cloneArray(this.dynamic_form.get([processed_section_list['section_id']]).value) || [];
              form_value_arr.push(Object.assign({}, section_form.value));
              this.dynamic_form.get([processed_section_list['section_id']]).setValue(cloneArray(form_value_arr));

              //setting value in sections array
              processed_section_list['data'] = [];
              // if (!(processed_section_list['data'] && typeof processed_section_list['data'] == 'object' && processed_section_list['data']['length'] >= 0)) {
              //   processed_section_list['data'] = [];
              // }
              processed_section_list['data'].push(Object.assign({}, section_form.value));
            }
          }
          processed_section_list['sections'] = multiSectionDataSave(processed_section_list['sections'], form_group);
          // delete (processed_section_list.multiple_form);
          processed_section_list = removeMultipleForm(processed_section_list);

          //Multiple conditition for section_data
          let processed_section_data;
          if (section_list.multiple) {
            processed_section_data = [form_group.value]
          }
          else {
            processed_section_data = form_group.value
          }
          //

          let section_data_value;
          if (section_list.multiple) {
            section_data_value = Object.assign({}, this.dynamic_form.get([section_list.section_id]).value);
            this.dynamic_form.get([section_list.section_id]).reset();
          }
          else {
            section_data_value = form_group.value;
          }


          this.dynamic_svc.apiCall('post', environment.SERVER_URL + processed_section_list['save_api_url'], { sections: [processed_section_list], data: this.dynamic_form.value, section_data: section_data_value, section_id: processed_section_list['section_id'], t_id: this.t_id }, this.other_data || null).subscribe(resData => { //

            if (resData && resData && resData['id'] && (resData['status'] || resData['status'] == null)) {
              if (!this.t_id) {
                this.t_id = resData['id'];
                // this.sharing_data['t_id'] = this.t_id;
              }
              this.dialogref.close(1);
              if (this.display_type == 3) {
                // this.stepper.next();
                // this.enableSave(section_list);
              }
              else {
                readOnlyMode(section_list);
                // this.cancel(section_list, this.dynamic_form.get([section_list.section_id]));
              }

              if (section_list.multiple) {
                form_group.reset();
              }
              //this.dataSaved(this.t_id);
            }
            this.notification_svc.success(resData['message']);
            // this.ngOnInit();
            // this.getMethod();
          },
            (err) => {

            })
        }

        //  If section is multiple, form_group value has to be pushed into data array and new form_group has to be added in the first index.
        //   If an edited entry is saved, 1. it has to be assigned back into the same index of data array 2. the form group which was used to create the entry has to be assigned to first index
        else {
          let section_form = section_list.multiple_form;

          //flow while editing existing record
          if (section_form.value.t_id) {

            //setting value in sections array
            for (let i = 0; i < section_list.data.length; i++) {
              if (section_list.data[i].t_id == section_form.value.t_id) {
                section_list.data[i] = section_form.value;
              }
            }

            //setting value for section_data obj.
            let found_in_form_group = 0;
            for (let i = 0; i < this.dynamic_form.get([section_list.section_id]).value.length; i++) {
              if (this.dynamic_form.get([section_list.section_id]).value[i].t_id == section_form.value.t_id) {
                let form_value_arr = cloneArray(this.dynamic_form.get([section_list.section_id]).value);
                form_value_arr[i] = section_form.value;
                this.dynamic_form.get([section_list.section_id]).patchValue(form_value_arr);
                found_in_form_group = 1;
              }
            }
            if (!found_in_form_group) {
              let form_value_arr = cloneArray(this.dynamic_form.get([section_list.section_id]).value);
              form_value_arr.push(section_form.value);
              this.dynamic_form.get([section_list.section_id]).patchValue(form_value_arr);
            }
          }

          //flow while adding a new record
          else {
            // if (!(this.edit_obj && this.edit_obj.index)) {
            //   //setting value for section_data obj.
            //   let form_value_arr = (this.dynamic_form.get([section_list.section_id]).value) || [];
            //   form_value_arr.push(section_form.value)
            //   this.dynamic_form.get([section_list.section_id]).patchValue(form_value_arr);

            //   //setting value in sections array
            //   section_list.data.push(section_form.value);
            // }
            // else {

            // }
          }

          section_form.reset();
          setTimeout(() => {
            // this.display_table = 1;
          })
        }
      }
      else {

        // this.notification_svc.snackbar("Please enter correct values!", "Cancel", 3000)
        this.markFormGroupTouched(form_group);
        let invalid_controls = findInvalidControls(form_group, section_list, this.translate, this.notification_svc);
      }
    }
    else if (!this.terms_conditions) {
      this._snackBar.open('Please accept the Terms and Conditions');
      // this.terms_conditions_req = "Please accept the Terms and Conditions";
    }
  }
  flagSecond(form_group) {
    if (form_group.invalid) {
      this.markFormGroupTouched(form_group);
      let invalid_controls = findInvalidControls(form_group, this.section_data[0], this.translate, this.notification_svc);
    }
    else {
      this.flag = 2;
    }
  }
  cancel() {
    this.dialogref.close(null);
  }
  parseResume(ev) {

    if (this.dynamic_form.dirty || this.t_id) {
      const dialogConfig = new MatDialogConfig()
      dialogConfig.width = "25%";
      dialogConfig.data = {
        title: "Confirmation",
        message: "Existing data will be replaced by the data parsed from resume document. Are you sure ?",
        positive_button: "Proceed",
        negative_button: "Cancel"
      };
      let ref = this.dialog.open(ConfirmationComponentCopy, dialogConfig);


      ref.afterClosed().subscribe(res => {
        if (res) {
          if (ev) {
            this.parseResumeDocument(ev);
          }
        }
      })
    }
    else {
      this.parseResumeDocument(ev);
    }
  }
  parser(section) {
    for (let i = 0; i < section.length; i++) {
      if (section[i] && section[i].data && typeof section[i].data == 'string') {
        while (typeof section[i].data != 'object') {
          section[i].data = jsonParse(section[i].data);
          // section[i].data.forEach(){

          // }
          for (let j = 0; j < section[i].data.length; j++) {
            let section_data = jsonParse(section[i].data[j]);
            if (section[i].multiple && !(section_data.t_id || section_data.random_id)) {
              section_data.random_id = Math.floor(Date.now() + Math.random() * 1000);
            }
          }
        }
      }
      if (section[i] && section[i].sections && typeof section[i].sections == 'string') {
        while (typeof section[i].sections != 'object') {
          section[i].sections = jsonParse(section[i].sections);


          if (section[i] && section[i].sections) {
            this.parser(section[i].sections);
          }
        }
      }
    }
    return section;
    // else {
    //   return section;
    // }
  }
  prepareSectionParsedData(sections, form, section_data, parsed_resume?, parent_form?) {
    sections = jsonParse(sections);
    if (sections && typeof sections == 'object') {
      for (let ind = 0; ind < sections.length; ind++) {

        if (parsed_resume && parsed_resume[ind] && parsed_resume[ind].data && section_data[ind].active_section) {
          sections[ind].data = cloneArray(jsonParse(parsed_resume[ind].data));
          // parsed_resume[ind].data = null;
        }
        else {
          sections[ind].data = jsonParse(sections[ind].data);
        }

        section_data[ind].data = jsonParse(sections[ind].data);

        if (sections[ind].data && !sections[ind].multiple) {
          if (sections[ind].data[0]) {
            if (sections[ind].field_details && typeof sections[ind].field_details == 'object' && sections[ind].field_details.length) {
              let fields = sections[ind].field_details;
              if (fields) {
                fields.forEach(field => {
                  if (field.control_type_id == 8) {

                    sections[ind].data[0][field.field_name] = jsonParse(sections[ind].data[0][field.field_name]);
                  }
                });
              }
            }
            if (form) {
              let section_form = form.get([sections[ind].section_id]);
              section_form.patchValue(sections[ind].data[0]);
            }
          }
        }
        else if (sections[ind].multiple) {

          parent_form.get([sections[ind].section_id]).patchValue(sections[ind].data);
        }

        if (parsed_resume && parsed_resume[ind] && parsed_resume[ind].data && section_data[ind].active_section) {
          parsed_resume[ind].data = null;
        }
        // form.addControl(sections[ind].section_id, section_form);

        if (section_data[ind].grid_layout) {
          section_data[ind].grid_layout = jsonParse(sections[ind].grid_layout);
        }

        sections[ind].sections = jsonParse(sections[ind].sections);
        if (sections[ind].sections && sections[ind].sections.length) {
          try {
            if (sections[ind].multiple) {
              this.prepareSectionParsedData(sections[ind].sections, sections[ind].multiple_form, section_data[ind].sections, parsed_resume[ind].sections, form.get([sections[ind].section_id]));
            }
            else {
              this.prepareSectionParsedData(sections[ind].sections, form.get([sections[ind].section_id]), section_data[ind].sections, parsed_resume[ind].sections, form.get([sections[ind].section_id]));

            }
          }
          catch (err) {

          }
        }
      }
    }
  }
  duplicate_resume_grid;
  parseResumeDocument(ev) {
    this.workbench_svc.parseResumeDetails({ resume_document: ev }, 9899, 0).subscribe(res => {

      if (res && res['data'] && res['data'].details && res['data'].details.length) {
        this.parsed_resume = this.parser(res['data'].details);
        this.prepareSectionParsedData(this.parser(res['data'].details), this.dynamic_form, this.section_data, this.parsed_resume, this.dynamic_form);
        checkActiveSection(this.section_data, this.display_type);

        this.change_detector.detectChanges();

        try {
          if (res['data'].duplicate_details && Object.keys(res['data'].duplicate_details) && Object.keys(res['data'].duplicate_details).length) {
            this.duplicate_resume_grid = jsonParse(res['data'].duplicate_details);
            this.notification_svc.snackbar("Resume already exists", "Close", 3000);
          }
        }
        catch (err) {

        }
      }
    })
  }
}

